import React from "react";

import Hero from "./Hero/Hero";
import Landing from "./Landing/Landing";

// fetching
import { useEffect, useState } from "react";
import useFetch from "Hooks/useFetch";
import IsLoading from "Components/RequestHandler/IsLoading";
import IsError from "Components/RequestHandler/IsError";
const Certificates = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("certificates");
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (isLoading) return <IsLoading />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main>
        <Hero />
        <Landing data={data?.certificates} />
      </main>
    );
  }
};

export default Certificates;
